"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.prepareProductForDataLayer = exports.getListClasses = exports.getLength = exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _readOnlyError2 = _interopRequireDefault(require("@babel/runtime/helpers/readOnlyError"));
var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));
var _react = _interopRequireDefault(require("react"));
var _reactRedux = require("react-redux");
var _mmcDataUtilities = _interopRequireDefault(require("@mmc-tools/mmc-data-utilities"));
var _text = require("@mmc/text");
var _navigationHeader = _interopRequireDefault(require("../styles/navigation-header.css"));
var _promotionLink = _interopRequireDefault(require("./promotion-link"));
var _productLinks = _interopRequireDefault(require("./product-links"));
var _subNavLinks = _interopRequireDefault(require("./sub-nav-links"));
var dataUtils = new _mmcDataUtilities["default"]();
var formatAsMKSPath = dataUtils.formatAsMKSPath,
  isEmptyArray = dataUtils.isEmptyArray;
var prepareProductForDataLayer = exports.prepareProductForDataLayer = function prepareProductForDataLayer(product, currencyFormat) {
  if (product) {
    var clonedProduct = JSON.parse(JSON.stringify(product));
    if (clonedProduct.cta && clonedProduct.cta.url) {
      clonedProduct.cta.url = formatAsMKSPath(clonedProduct.cta.url);
    }
    if (clonedProduct.price) {
      clonedProduct.price.currency = currencyFormat;
    }
    return clonedProduct;
  }
  return product;
};
var getListClasses = exports.getListClasses = function getListClasses(params) {
  var menuOpen = params.menuOpen,
    theme = params.theme,
    isLast = params.isLast;
  return _navigationHeader["default"].navBtnItem + " " + (menuOpen ? null : theme.grey) + " " + _navigationHeader["default"].subColumnWrap + " " + (isLast ? _navigationHeader["default"].lastBtnItem : '') + " menu-panel-top-level-item";
};
var getLength = exports.getLength = function getLength(arr) {
  return arr && arr.length;
};
var MenuPanelSubColumn = /*#__PURE__*/function (_React$Component) {
  function MenuPanelSubColumn(props) {
    var _this;
    _this = _React$Component.call(this, props) || this;
    var keyHandler = props.keyHandler || _this.keyHandler.bind(_this);
    _this.focusHandler = _this.focusHandler.bind(_this);
    _this.refList = {};
    _this.state = {
      keyHandler: keyHandler
    };
    return _this;
  }
  (0, _inheritsLoose2["default"])(MenuPanelSubColumn, _React$Component);
  var _proto = MenuPanelSubColumn.prototype;
  _proto.keyHandler = function keyHandler() {
    var keyHandlerMethod = this.props.keyHandlerMethod;
    keyHandlerMethod.apply(void 0, arguments);
  };
  _proto.focusHandler = function focusHandler() {
    var focusHandler = this.props.focusHandler;
    if (focusHandler !== undefined) {
      focusHandler(true);
    }
  };
  _proto.render = function render() {
    var _this$props = this.props,
      name = _this$props.name,
      keyHandler = _this$props.keyHandler,
      clickHandler = _this$props.clickHandler,
      activeNav = _this$props.activeNav,
      subNavigationcontainer = _this$props.subNavigationcontainer,
      addPriceDisclaimer = _this$props.addPriceDisclaimer,
      priceDisclaimerId = _this$props.priceDisclaimerId,
      disclaimerData = _this$props.disclaimerData,
      setSize = _this$props.setSize,
      posInSet = _this$props.posInSet,
      menuOpen = _this$props.menuOpen,
      isLast = _this$props.isLast,
      theme = _this$props.theme,
      links = _this$props.links,
      products = _this$props.products,
      displayNavInTwoColumns = _this$props.displayNavInTwoColumns,
      market = _this$props.market,
      config = _this$props.config,
      currentPath = _this$props.currentPath,
      keyHandlerMethod = _this$props.keyHandlerMethod,
      mobileNavActive = _this$props.mobileNavActive; // eslint-disable-line
    var subNavigationItems = subNavigationcontainer.subNavigationItems,
      promoterDetails = subNavigationcontainer.promoterDetails;
    var id = name.toLowerCase();
    var layout = products.length > 0 ? 'products' : 'feature';
    var linkSetSize = getLength(links) ? links.length : 0;
    var productSetSize = getLength(products) ? products.length : 0;
    var totalSetSize = linkSetSize + productSetSize;
    var expanded = activeNav === id && menuOpen && !mobileNavActive;
    var hasPopUp = !!(linkSetSize || productSetSize);
    var reducedHeight = !(links.length > 0 && products.length === 0);
    return /*#__PURE__*/_react["default"].createElement("li", {
      className: getListClasses({
        menuOpen: menuOpen,
        theme: theme,
        isLast: isLast
      }),
      role: "menuitem",
      "aria-expanded": expanded,
      "aria-setsize": setSize,
      "aria-posinset": posInSet,
      "aria-haspopup": hasPopUp,
      "data-menu-item-name": name
    }, /*#__PURE__*/_react["default"].createElement("button", {
      className: _navigationHeader["default"].navBtn + " " + theme.lowIcon + " " + theme.mmcIconChevronDown,
      onKeyDown: keyHandler,
      onFocus: this.focusHandler,
      onClick: clickHandler,
      type: "button"
    }, /*#__PURE__*/_react["default"].createElement("span", null, name)), /*#__PURE__*/_react["default"].createElement("div", {
      className: _navigationHeader["default"].navPanel + " " + _navigationHeader["default"].restrictHeight + " " + _navigationHeader["default"][layout] + " " + (_navigationHeader["default"][id] ? _navigationHeader["default"][id] : '')
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _navigationHeader["default"].innerLinkContainer + " " + (displayNavInTwoColumns === true ? _navigationHeader["default"].displayNavInTwoColumns : '')
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "products"
    }, /*#__PURE__*/_react["default"].createElement(_productLinks["default"], {
      products: products,
      theme: theme,
      totalSetSize: totalSetSize,
      name: name,
      addPriceDisclaimer: addPriceDisclaimer,
      priceDisclaimerId: priceDisclaimerId,
      disclaimerData: disclaimerData,
      market: market,
      config: config,
      currentPath: currentPath,
      keyHandlerMethod: keyHandlerMethod
    })), !isEmptyArray(subNavigationItems) && /*#__PURE__*/_react["default"].createElement("div", {
      className: theme.row + " " + _navigationHeader["default"].navPromoWrapper
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: theme['col-sm-7'] + " " + theme['col-sm-offset-1'] + " " + theme['col-xs-12'] + " " + _navigationHeader["default"].subNavigationContainer
    }, /*#__PURE__*/_react["default"].createElement(_subNavLinks["default"], {
      reducedHeight: reducedHeight,
      totalSetSize: totalSetSize,
      name: name,
      displayNavInTwoColumns: displayNavInTwoColumns,
      market: market,
      theme: theme,
      subNavigationItems: subNavigationItems,
      keyHandlerMethod: keyHandlerMethod
    })), /*#__PURE__*/_react["default"].createElement("div", {
      className: "" + theme['col-xs-4']
    }, /*#__PURE__*/_react["default"].createElement(_promotionLink["default"], (0, _extends2["default"])({
      mobileNavActive: mobileNavActive
    }, promoterDetails, {
      theme: theme
    })))))));
  };
  return MenuPanelSubColumn;
}(_react["default"].Component);
MenuPanelSubColumn.displayName = 'MenuPanelSubColumn';
MenuPanelSubColumn.defaultProps = {
  links: [],
  products: []
};
var mapStateToProps = function mapStateToProps(state) {
  return {
    config: state.Config
  };
};
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps, function (dispatch) {
  return {
    dispatch: dispatch
  };
})(MenuPanelSubColumn);